module.exports = __webpack_public_path__ + "static/media/permanent-menu.a0eaf6da.svg";